export const WHATSAPP_NUMBER = "9647883320076";

export const PHONES = ["07883320076", "07777756130", "07883320075", "07777792388"];

export const intl = (local) => "964" + local.replace(/^0/, "");

export function waLink(message) {
  return `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
}

export function waChatLink(message, number = WHATSAPP_NUMBER) {
  return `https://wa.me/${number}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
}

export function shareWhatsApp(message) {
  window.open(waLink(message), "_blank", "noopener,noreferrer");
}
